import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST,
  GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS,
  GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE,
} = DashboardConstants;

function* getDashboardSupervisorEdit(): SagaReturnType<any> {
  try {
    const response = yield call(dashboardServices.getDashboardSupervisorEdit);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_SUPERVISOR_EDIT_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_SUPERVISOR_EDIT_FAILURE, payload: error });
  }
}

function* dashboardSupervisorEditSaga() {
  yield takeEvery(GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST, getDashboardSupervisorEdit);
}

export default dashboardSupervisorEditSaga;
